<template>
  <div class="list-group-item">
    <input
      :id="`selectMunicipalityCheck-${municipality.insee}`"
      v-model="selected"
      class="form-check-input"
      type="checkbox"
      value=""
    >
    <label
      class="form-check-label"
      :for="`selectMunicipalityCheck-${municipality.insee}`"
    >
      {{ municipality.displayName }}
    </label>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'MunicipalitiesSelectorItem',

  props: {
    municipality: {
      type: Object,
      default: () => {
        return {};
      }
    },
    selectAll: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: false,
      handlingSelectAll: false
    };
  },

  computed: {
    ...mapState('municipalities', [
      'selectedMunicipalities'
    ])
  },

  watch: {
    selectAll(newValue) {
      this.handlingSelectAll = true;
      this.selected = newValue;
    },
    async selected(newValue) {
      if (!this.handlingSelectAll) {
        if (newValue) {
          await this.SELECT_MUNICIPALITY(this.municipality);
        } else {
          await this.DESELECT_MUNICIPALITY(this.municipality);
        }
      }
      this.handlingSelectAll = false;
    },
    selectedMunicipalities: {
      deep: true,
      handler(newValue) {
        if (newValue.find(el => el.insee === this.municipality.insee)) {
          this.selected = true;
        } else {
          this.selected = false;
        }
      }
    }
  },

  created() {
    if (this.selectedMunicipalities.find(el => el.insee === this.municipality.insee)) {
      this.selected = true;
    } else {
      this.selected = false;
    }
  },

  methods: {
    ...mapActions('municipalities', [
      'SELECT_MUNICIPALITY',
      'DESELECT_MUNICIPALITY'
    ])
  }
};
</script>

<style lang="less" scoped>
.list-group-item {
  padding: 0.5rem 1rem;
  .form-check-input {
    cursor: pointer;
    margin-left: 0;
  }
  .form-check-label {
    margin-left: 1.5rem;
  }
}
</style>